import { PlcBrand } from './types';

export const PLC_BRANDS = [
  { value: PlcBrand.Siemens, label: 'Siemens (TIA Portal)', icon: 'S' },
  { value: PlcBrand.AllenBradley, label: 'Allen-Bradley (Studio 5000)', icon: 'AB' },
  { value: PlcBrand.Beckhoff, label: 'Beckhoff (TwinCAT 3)', icon: 'B' },
  { value: PlcBrand.Codesys, label: 'CODESYS (Generic)', icon: 'C' },
  { value: PlcBrand.Inovance, label: 'Inovance (汇川)', icon: 'I' },
  { value: PlcBrand.ABB, label: 'ABB (Automation Builder)', icon: 'ABB' },
  { value: PlcBrand.Mitsubishi, label: 'Mitsubishi (GX Works3)', icon: 'M' },
  { value: PlcBrand.Omron, label: 'Omron (Sysmac Studio)', icon: 'O' },
];

export const AI_PROVIDERS = [
  { value: 'realplc', label: 'RealPLC', baseUrl: '' },
  { value: 'nvidia', label: 'Nvidia', baseUrl: 'https://integrate.api.nvidia.com/v1' },
  { value: 'google', label: 'Google', baseUrl: 'https://generativelanguage.googleapis.com/v1beta/openai' },
  { value: 'openai', label: 'OpenAI', baseUrl: 'https://api.openai.com/v1' },
  { value: 'groq', label: 'Groq', baseUrl: 'https://api.groq.com/openai/v1' },
  { value: 'openrouter', label: 'OpenRouter', baseUrl: 'https://openrouter.ai/api/v1' },
  { value: 'deepseek', label: 'DeepSeek', baseUrl: 'https://api.deepseek.com/v1' },
  { value: 'zai', label: 'Z.AI (GLM-5.1)', baseUrl: 'https://api.z.ai/api/paas/v4' },
  { value: 'zhipu', label: 'Zhipu (BigModel)', baseUrl: 'https://open.bigmodel.cn/api/paas/v4' },
  { value: 'moonshot', label: 'Moonshot (Kimi)', baseUrl: 'https://api.moonshot.cn/v1' },
  { value: 'minimax', label: 'MiniMax', baseUrl: 'https://api.minimax.chat/v1' },
  { value: 'aliyun', label: 'Aliyun Bailian', baseUrl: 'https://dashscope.aliyuncs.com/compatible-mode/v1' },
  { value: 'siliconflow', label: 'SiliconFlow', baseUrl: 'https://api.siliconflow.cn/v1' },
  { value: 'baicai', label: 'BaiCai', baseUrl: 'https://llm.develope.cn/claude' },
  { value: 'custom', label: 'Custom Provider', baseUrl: '' },
];

export const AI_MODELS = [
  // RealPLC AutoFree
  { value: 'autofree', label: 'AutoFree', provider: 'realplc' },
  // Custom OpenAI-compatible model. The actual model id is entered by the user.
  { value: 'custom', label: 'Custom Model', provider: 'custom' },
  // Nvidia
  { value: 'deepseek-ai/deepseek-v3.2', label: 'DeepSeek V3.2', provider: 'nvidia' },
  { value: 'deepseek-ai/deepseek-r1-distill-llama-8b', label: 'DeepSeek R1 Distill Llama 8B', provider: 'nvidia' },
  { value: 'meta/llama-3.1-405b-instruct', label: 'Llama 3.1 405B', provider: 'nvidia' },
  { value: 'meta/llama-3.1-70b-instruct', label: 'Llama 3.1 70B', provider: 'nvidia' },
  { value: 'moonshotai/kimi-k2.5', label: 'Kimi K2.5', provider: 'nvidia' },
  { value: 'minimaxai/minimax-m2.5', label: 'MiniMax M2.5', provider: 'nvidia' },
  { value: 'openai/gpt-oss-120b', label: 'GPT-OSS 120B', provider: 'nvidia' },
  { value: 'stepfun-ai/step-3.5-flash', label: 'Step-3.5 Flash', provider: 'nvidia' },
  { value: 'qwen/qwen3-coder-480b-a35b-instruct', label: 'Qwen3 Coder 480B', provider: 'nvidia' },
  { value: 'z-ai/glm5', label: 'GLM-5', provider: 'nvidia' },
  { value: 'nvidia/llama-3.2-11b-vision-instruct', label: 'Llama 3.2 11B Vision (NIM)', provider: 'nvidia', mode: 'fast' },
  { value: 'nvidia/llama-3.2-90b-vision-instruct', label: 'Llama 3.2 90B Vision (NIM)', provider: 'nvidia', mode: 'thinking' },
  // Google
  { value: 'gemini-3.1-pro', label: 'Gemini 3.1 Pro', provider: 'google' },
  { value: 'gemini-3.1-flash', label: 'Gemini 3.1 Flash', provider: 'google' },
  { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro (Vision)', provider: 'google', mode: 'thinking' },
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash (Vision)', provider: 'google', mode: 'fast' },
  // OpenAI
  { value: 'gpt-5.4', label: 'GPT-5.4', provider: 'openai' },
  { value: 'llama-3.3-70b-versatile', label: 'GPT-5.4-mini', provider: 'openai' },
  { value: 'o3', label: 'o3', provider: 'openai' },
  { value: 'o3-pro', label: 'o3-pro', provider: 'openai' },
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini (Vision)', provider: 'openai', mode: 'fast' },
  // Anthropic (via OpenRouter)
  { value: 'anthropic/claude-4-opus', label: 'Claude 4 Opus', provider: 'openrouter' },
  { value: 'anthropic/claude-3.5-sonnet', label: 'Claude 3.5 Sonnet', provider: 'openrouter' },
  { value: 'anthropic/claude-3.5-haiku', label: 'Claude 3.5 Haiku', provider: 'openrouter' },
  // OpenRouter
  { value: 'openrouter/auto', label: 'Auto', provider: 'openrouter' },
  { value: 'openai/gpt-oss-120b', label: 'GPT-OSS 120B', provider: 'openrouter' },
  { value: 'openai/gpt-5.4:free', label: 'GPT-5.4', provider: 'openrouter' },
  { value: 'openai/gpt-4o-mini', label: 'GPT-4o Mini (Vision)', provider: 'openrouter', mode: 'fast' },
  { value: 'meta-llama/llama-4-70b', label: 'Llama 4 70B', provider: 'openrouter' },
  { value: 'mistralai/mistral-large-3', label: 'Mistral Large 3', provider: 'openrouter' },
  { value: 'qwen/qwen-3.6-72b', label: 'Qwen 3.6 72B', provider: 'openrouter' },
  // DeepSeek
  { value: 'deepseek-v4-flash', label: 'DeepSeek-V4-Flash', provider: 'deepseek' },
  { value: 'deepseek-v4-pro', label: 'DeepSeek-V4-Pro', provider: 'deepseek' },
  { value: 'deepseek-chat', label: 'DeepSeek-Chat', provider: 'deepseek' },
  { value: 'deepseek-reasoner', label: 'DeepSeek-Reasoner', provider: 'deepseek' },
  // Zhipu (GLM)
  { value: 'glm-5.1', label: 'GLM-5.1', provider: 'zhipu' },
  { value: 'glm-5', label: 'GLM-5', provider: 'zhipu' },
  { value: 'glm-5-turbo', label: 'GLM-5-Turbo', provider: 'zhipu' },
  { value: 'glm-4.7', label: 'GLM-4.7', provider: 'zhipu' },
  { value: 'glm-4.7-flashx', label: 'GLM-4.7-FlashX', provider: 'zhipu' },
  { value: 'glm-4.7-flash', label: 'GLM-4.7-Flash', provider: 'zhipu' },
  { value: 'glm-4-plus', label: 'GLM-4 Plus', provider: 'zhipu' },
  { value: 'glm-4v-flash', label: 'GLM-4V Flash', provider: 'zhipu', mode: 'fast' },
  // Moonshot (Kimi)
  { value: 'kimi-k2.5', label: 'Kimi K2.5', provider: 'moonshot' },
  { value: 'kimi-dev', label: 'Kimi-Dev', provider: 'moonshot' },
  { value: 'kimi-k2.5-lite', label: 'Kimi K2.5 Lite', provider: 'moonshot' },
  // MiniMax
  { value: 'minimax-m2.7', label: 'MiniMax-M2.7', provider: 'minimax' },
{ value: 'minimax-m2.5', label: 'MiniMax-M2.5', provider: 'minimax' },
  // Aliyun Bailian
  { value: 'qwen-3.6-plus', label: 'Qwen 3.6 Plus', provider: 'aliyun' },
  { value: 'qwen-max', label: 'Qwen-Max', provider: 'aliyun' },
  { value: 'qwen-flash', label: 'Qwen-Flash', provider: 'aliyun' },
  { value: 'qwen3.5-122b-a10b', label: 'Qwen3.5 122B', provider: 'aliyun' },
  { value: 'qwen3-coder-next', label: 'Qwen3 Coder Next', provider: 'aliyun' },
  { value: 'qwen3.5-397b-a17b', label: 'Qwen3.5 397B', provider: 'aliyun' },
  { value: 'glm-5', label: 'GLM-5', provider: 'aliyun' },
  { value: 'glm-4.7', label: 'GLM-4.7', provider: 'aliyun' },
  { value: 'kimi-k2-thinking', label: 'Kimi K2 Thinking', provider: 'aliyun' },
  { value: 'deepseek-r1', label: 'DeepSeek R1', provider: 'aliyun' },
  { value: 'deepseek-r1-distill-qwen-32b', label: 'DeepSeek R1 Distill Qwen 32B', provider: 'aliyun' },
  { value: 'minimax-m2.5', label: 'MiniMax M2.5', provider: 'aliyun' },
  // SiliconFlow
  { value: 'Qwen/Qwen3.5-4B', label: 'Qwen3.5 4B', provider: 'siliconflow' },
  { value: 'GLM-4.1V-9B-Thinking', label: 'GLM-4.1V 9B Thinking', provider: 'siliconflow' },
  { value: 'deepseek-ai/DeepSeek-R1-0528-Qwen3-8B', label: 'DeepSeek R1 Qwen3 8B', provider: 'siliconflow' },
  { value: 'deepseek-ai/DeepSeek-R1-Distill-Qwen-7B', label: 'DeepSeek R1 Distill Qwen 7B', provider: 'siliconflow' },
  // Groq
  { value: 'groq/compound', label: 'compound', provider: 'groq' },
  { value: 'llama-3.3-70b-versatile', label: 'llama-3.3-70b', provider: 'groq' },
  { value: 'openai/gpt-oss-120b', label: 'gpt-oss-120b', provider: 'groq' },
  { value: 'qwen/qwen3-32b', label: 'Qwen3-32b', provider: 'groq' },
];

export const VISIBLE_AI_PROVIDER_VALUES = ['realplc', 'zhipu', 'deepseek', 'custom'] as const;
export const CUSTOM_AI_PROVIDER = 'custom';
export const CUSTOM_AI_MODEL = 'custom';

export const VISIBLE_AI_PROVIDERS = AI_PROVIDERS.filter((provider) =>
  VISIBLE_AI_PROVIDER_VALUES.includes(provider.value as typeof VISIBLE_AI_PROVIDER_VALUES[number])
).map((provider) =>
  provider.value === 'zhipu' ? { ...provider, label: 'GLM' } : provider
);

export const VISIBLE_AI_MODELS = AI_MODELS.filter((model) =>
  VISIBLE_AI_PROVIDER_VALUES.includes(model.provider as typeof VISIBLE_AI_PROVIDER_VALUES[number])
);

export const SAMPLE_PROMPTS = [
  "Control a conveyor belt with start/stop buttons, a safety e-stop, and a 10s timeout if the sensor isn't triggered.",
  "Create a PID temperature control loop for a heating element with anti-windup.",
  "Implement a traffic light sequence for a 4-way intersection using timers and states.",
  "Write a function block to handle a motor starter with overload protection and feedback monitoring.",
  "Control a liquid tank with inlet/outlet valves, level sensors, and start/stop buttons.",
  "Control a multi-step batch recipe process including ingredient dosing, mixing, and discharging.",
  "Implement an alarm handler with priority levels, acknowledgment, auto-reset, and horn control.",
  "Create a circular data logger to record analog values and timestamps into a buffer.",
  "Automate a packaging line including filling, sealing, labeling, and rejection functions.",
  "Control a heating/cooling HVAC system with zone temperatures, fan speeds, and scheduling."
];
